export default "__VITE_ASSET__f025b2c7__"